module.exports = __webpack_public_path__ + "img/sytLogo2.423db0e0.jpg";